<template>
  <div class="row animated--fade-in">
    <div class="col-12 d-flex "
         :style="this.$route.name === 'Chat' ? 'min-height: 90vh;' : this.$route.name === 'Channel' ? 'min-height: 30vh;' : 'min-height: 70vh;' "
         style="justify-content: center;
                    align-items: center;">
      <div class="row">
        <div class="col-12 text-center">
          <div class="d-flex" style="justify-content: center;" v-if="this.$route.name === 'Chat'">
            <lottie-player src="https://lottie.host/9b4607a3-eb9b-4a1e-a07c-dba1caf8735f/5I9zbovbnp.json"
                       background="transparent" speed="0.5" direction="1" mode="normal" loop autoplay
                       :style="($mq === 'mobile' || $mq === 'tablet') ?
                                            'width: 100%; height: 350px;' :
                                            'width: 600px; height: 350px;'">
            </lottie-player>
          </div>
          <div v-else class="spinner-border text--primary"
               style="width: 3.5rem; height: 3.5rem;"
               role="status">
          </div>
        </div>
        <div class="col-12 text-center cursor_default">
          <h4 v-if="this.$route.name === 'Chat'"><b>Carregando mensagens, por favor aguarde...</b></h4>
          <small v-else class="bx-flashing">
            {{ getTranslations('expression_36') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Loader",
  computed: {
    ...mapGetters([])
  }
}
</script>

<style scoped>

</style>
